<template>
  <div class="auth">
    <button class="back" type="button" @click="goBack">
        <span>←</span>&nbsp;&nbsp;
        <span>Back</span>
    </button>
    <div class="bg-grid"></div>
    <div class="card">
      <div class="brand">
        <div class="logo">SC</div>
        <div class="brand-text">
          <div class="title">Sheet Creator</div>
          <div class="subtitle">Pre-register to get early access</div>
        </div>
      </div>

      <form @submit.prevent="onSubmit" novalidate>
        <div class="field">
          <label for="email">Email</label>
          <input
            id="email"
            type="email"
            v-model.trim="email"
            autocomplete="email"
            placeholder="you@example.com"
            :class="{ invalid: error }"
          />
          <div v-if="error" class="error">{{ error }}</div>
        </div>

        <button class="btn primary" type="submit" :disabled="submitting">
          <span v-if="!submitting && !submitted">Pre-register</span>
          <span v-else-if="submitting">Submitting…</span>
          <span v-else>You're on the list</span>
        </button>
      </form>

      <p v-if="submitted" class="meta">
        Thanks — we’ll email you when the beta is ready.
      </p>
    </div>

    <footer class="foot">@ {{ new Date().getFullYear() }} Sheet Creator</footer>
  </div>
</template>

<script>
export default {
    name: 'PreRegisterView',
    data() {
        return {
            email: '',
            error: '',
            submitting: false,
            submitted: false,
        }
    },
    methods: {
        validate() {
            this.error = ''
            if (!this.email) {
                this.error = 'Email is required'
            } else if (!/.+@.+\..+/.test(this.email)) {
                this.error = 'Enter a valid email'
            }
            return !this.error
        },
        async onSubmit() {
            if (!this.validate()) return
            this.submitting = true
            this.submitted = false

            this.$store.dispatch('events/sendUserEvent', {
                event_action: 'preregister.submit',
            })
            this.$store.dispatch('preRegisterUser', {
                email: this.email
            })

            setTimeout(() => {
                this.submitting = false
                this.submitted = true
            }, 800);
        },
        goBack() {
            this.$router.push({ name: 'main' })
        },
    },
}
</script>

<style scoped>
.auth {
  --grad-1: var(--panel);
  --grad-2: var(--panel-2);
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: radial-gradient(1200px 800px at 20% -10%, #1a2a5a20, transparent),
    radial-gradient(1000px 700px at 100% 120%, #3b8bff15, transparent),
    linear-gradient(180deg, var(--grad-1), var(--grad-2));
  color: var(--text);
  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto,
    Helvetica, Arial, 'Apple Color Emoji', 'Segoe UI Emoji';
  position: relative;
  overflow: hidden;
}

.bg-grid {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      0deg,
      transparent 24%,
      rgba(255, 255, 255, 0.03) 25%,
      rgba(255, 255, 255, 0.03) 26%,
      transparent 27%,
      transparent 74%,
      rgba(255, 255, 255, 0.03) 75%,
      rgba(255, 255, 255, 0.03) 76%,
      transparent 77%,
      transparent
    ),
    linear-gradient(
      90deg,
      transparent 24%,
      rgba(255, 255, 255, 0.03) 25%,
      rgba(255, 255, 255, 0.03) 26%,
      transparent 27%,
      transparent 74%,
      rgba(255, 255, 255, 0.03) 75%,
      rgba(255, 255, 255, 0.03) 76%,
      transparent 77%,
      transparent
    );
  background-size: 40px 40px;
  opacity: 0.35;
  pointer-events: none;
}

.card {
  width: 420px;
  max-width: 92vw;
  background: linear-gradient(180deg, var(--panel), var(--panel-2));
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.45), 0 1px 0 rgba(255, 255, 255, 0.04) inset;
  padding: 20px;
  position: relative;
}

.back {
    position: absolute;
    top: 16px;
    left: 16px;
    background: transparent;
    border: none;
    color: var(--muted);
    font-size: 14px;
    cursor: pointer;
    padding: 4px 8px;
    display: flex;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}
.logo {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--accent);
  display: grid;
  place-items: center;
  color: white;
  font-weight: 700;
  letter-spacing: 0.5px;
}
.brand-text .title {
  font-weight: 700;
  letter-spacing: 0.2px;
  font-family: 'Inter', inherit;
}
.brand-text .subtitle {
  color: var(--muted);
  font-size: 12px;
  margin-top: 2px;
}

form {
  display: grid;
  gap: 12px;
  margin-top: 8px;
}
.field {
  display: grid;
  gap: 6px;
}
label {
  color: var(--muted);
  font-size: 12px;
}
input[type='email'] {
  height: 38px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--panel-2);
  color: var(--text);
  padding: 0 12px;
  font-size: 14px;
}
input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px #5b8cff33;
}
.invalid {
  border-color: #ff6b6b !important;
}
.error {
  color: #ff9a9a;
  font-size: 12px;
}

.btn {
    height: 38px;
    border-radius: 10px;
    border: 1px solid var(--border);
    background: var(--accent);
    color: #fff;
    cursor: pointer;
    padding: 0 14px;
    font-weight: 600;
}
.btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.meta {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    gap: 6px;
    color: var(--muted);
    font-size: 13px;
}

.foot {
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    color: var(--muted);
    font-size: 12px;
    opacity: 0.8;
}

@media (max-width: 480px) {
    .card {
        padding: 16px;
        border-radius: 12px;
    }
    .logo {
        width: 32px;
        height: 32px;
    }
}
</style>

